import React, { useEffect, useState } from "react";
import './straightForwardPricing.css';
import circleImg from '../../images/circle.svg';
import { getTokenFromLS } from "../../lib/helpers";
import { Link, useParams, useHistory } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import setting from '../../images/setting.svg';
import deleteIcon from '../../images/delete.svg';
import refreshIcon from '../../images/refresh.svg';
import Back from "../../images/Arrow back.svg"
import Swal from "sweetalert2";
import posthog from 'posthog-js';

const moment = require('moment');

const StraightForwardPricing = ({ user, currentSubscription, upcomingSubscription }) => {
    const [monthlySelected, setMonthlySelected] = useState(true);
    const [allPlan, setAllPlan] = useState([]);
    const [loading, setLoading] = useState({ click: false, index: -1 });
    const [heightOfSFP, setHeight] = useState(window.innerHeight - 70);
    const [loadSetting, setLoadSetting] = useState('');
    const [subscription, setSubscription] = useState(currentSubscription);
    const [deleteUpcomingSubLoader, setDeleteUpcomingSubLoader] = useState('');
    const [showSurvey, setShowSurvey] = useState(false);
    const [surveyData, setSurveyData] = useState(null);
    const [surveyResponse, setSurveyResponse] = useState('');
    const history = useHistory();
    const [upcomingSub, setUpCommingSub] = useState({
        upcomingSubscription: {
            planId: null,
            planName: null,
            startDate: null
        }
    })
    const surveyId = process.env.REACT_APP_PUBLIC_POSTHOG_SURVEY_ID || "";
    const detectHeight = () => {
        setHeight(window.innerHeight - 70)
    };
    // const goBackBtn = () => {    
    //     window.location.href = '/'
    //   };
    useEffect((() => {
        window.addEventListener('resize', detectHeight);
        setSubscription(currentSubscription);
        return () => {
            window.addEventListener('resize', detectHeight);
        }

    }), [heightOfSFP, currentSubscription])

    const goBackBtn = () => {

        window.location.href = '/pixie';
      };
    const fetchAllPlans = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}subscription/getAllPlans`);
            const data = await response.json();

            if (data?.success) {
                // data.plans.forEach((ele, index) => {
                //     if (ele.billing_period === 1) {
                //         setMonthlyPlan(monthlyPlan => [...monthlyPlan, ele]);
                //     } else if (ele.billing_period === 12) {
                //         setYearlyPlan(yearlyPlan => [...yearlyPlan, ele]);
                //     }
                // })
                setAllPlan(data.plans);
                if (upcomingSubscription?.planId) {
                    setUpCommingSub({
                        upcomingSubscription: {
                            planId: upcomingSubscription.planId,
                            planName: data.plans.find(ele => ele._id === upcomingSubscription.planId)?.name,
                            startDate: upcomingSubscription.startDate
                        }
                    })
                }
            }

            return 0;
        } catch (error) {
            console.log(error)
        }
    }

    useEffect((() => {
        fetchAllPlans();
        window.addEventListener('resize', detectHeight);
    }), []);

    const onClickBtn = (ele, index) => {
        if (!loading.click) {
            setLoading({ click: true, index: index });
            checkout(ele._id)
        }
    }

    const onClickBtnUpgradePlan = (ele, index) => {
        if (upcomingSub.upcomingSubscription?.planId === ele._id) { } else {
            if (!loading.click) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You want to upgrade this plan!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Upgrade it!',
                    showLoaderOnConfirm: true,
                    allowOutsideClick: () => {},
                    preConfirm: (login) => {
                        setLoading({ click: true, index: index });
                        checkout(ele._id)
                    },
                })
            }
        }
    }

    const deleteScheduledSubscription = async () => {
        setDeleteUpcomingSubLoader('settingIcon-CP-img-click');
        try {
            setDeleteUpcomingSubLoader('settingIcon-CP-img-click');
            const token = window.localStorage.getItem("token");
            if (token) {
                const result = await fetch(`${process.env.REACT_APP_API_ENDPOINT}subscription/cancel-upcoming`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        token: token,
                    },
                });
                const res = await result.json();
                if (res.success) {
                    Swal.fire({
                        position: 'top-cneter',
                        icon: 'success',
                        title: 'Done',
                        text: 'Upcoming plan has been cancelled!',
                    });
                    setSubscription(prevValue => ({ ...prevValue, cancelsAt: res.data.cancelsAt, status: res.data.status }));
                    setUpCommingSub({
                        upcomingSubscription: {
                            planId: null
                        }
                    })
                } else {
                    Swal.fire({
                        position: 'top-cneter',
                        icon: 'error',
                        title: 'Oops...',
                        text: res?.message || 'Something went wrong!',
                    });
                }
                setDeleteUpcomingSubLoader('');
            }
        } catch (error) {
            console.log("Error while cancelling the upcoming plan =>", error);
            setDeleteUpcomingSubLoader('');
            Swal.fire({
                position: 'top-cneter',
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
            })
        }
    }
    const onClickCancelScheduledPlan = (ele, index) => {
        if (!deleteUpcomingSubLoader) { 
            Swal.fire({
                title: 'Are you sure?',
                text: "You want to cancel this Upcoming plan!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Cancel it!',
                showLoaderOnConfirm: true,
                allowOutsideClick: () => {},
                preConfirm: () => {
                    deleteScheduledSubscription();
                },
            })
        }
    }


    const cancelCurrentSubscription = async () => {
        setDeleteUpcomingSubLoader('settingIcon-CP-img-click');
        try {
            setDeleteUpcomingSubLoader('settingIcon-CP-img-click');
            const token = window.localStorage.getItem("token");
            if (token) {
                const result = await fetch(`${process.env.REACT_APP_API_ENDPOINT}subscription/cancel-current-plan`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        token: token,
                    },
                });
                const res = await result.json();
                if (res.success) {
                    Swal.fire({
                        position: 'top-cneter',
                        icon: 'success',
                        title: 'Done',
                        text: 'Your plan has been cancelled!',
                    });
                    posthog.capture('PlanCancelled',{
                        $set: {planPrice: null,planActive: false},
                        planPrice:allPlan.find(ele => ele._id === res.data.planId)?.price.toString()
                      });
                      posthog.getActiveMatchingSurveys((surveys) => {
                        const targetSurvey = surveys.find(survey => survey.id === surveyId);
                        if (targetSurvey) {
                            setSurveyData(targetSurvey);
                            setShowSurvey(true);
                            posthog.capture("survey shown", {
                                $survey_id: targetSurvey.id
                            }) 
                        }
                    });
                    console.log('here is the cancelled Subscription ===>>', res.data);
                    setSubscription(prevValue => ({ ...prevValue, cancelsAt: res.data.cancelsAt, status: res.data.status }));
                    // fetchAllPlans();
                } else {
                    Swal.fire({
                        position: 'top-cneter',
                        icon: 'error',
                        title: 'Oops...',
                        text: res?.message || 'Something went wrong!',
                    });
                }
                setDeleteUpcomingSubLoader('');
            }
        } catch (error) {
            console.log("Error while cancelling the upcoming plan =>", error);
            setDeleteUpcomingSubLoader('');
            Swal.fire({
                position: 'top-cneter',
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
            })
        }
    }
    const renewCurrentSubscription = async () => {
        setDeleteUpcomingSubLoader('settingIcon-CP-img-click');
        try {
            setDeleteUpcomingSubLoader('settingIcon-CP-img-click');
            const token = window.localStorage.getItem("token");
            if (token) {
                const result = await fetch(`${process.env.REACT_APP_API_ENDPOINT}subscription/renew-current-plan`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        token: token,
                    },
                });
                const res = await result.json();
                if (res.success) {
                    Swal.fire({
                        position: 'top-cneter',
                        icon: 'success',
                        title: 'Done',
                        text: 'Your plan has been renewed!',
                    });
                    posthog.capture('PlanRenewal',{
                        $set: {planPrice: allPlan.find(ele => ele._id === res.data.planId)?.price,planActive: true},
                        planPrice:allPlan.find(ele => ele._id === res.data.planId)?.price.toString()
                    });
                    setSubscription(prevValue => ({ ...prevValue, cancelsAt: res.data.cancelsAt, status: res.data.status }));
                } else {
                    Swal.fire({
                        position: 'top-cneter',
                        icon: 'error',
                        title: 'Oops...',
                        text: res?.message || 'Something went wrong!',
                    });
                }
                setDeleteUpcomingSubLoader('');
            }
        } catch (error) {
            console.log("Error while renewing the upcoming plan =>", error);
            setDeleteUpcomingSubLoader('');
            Swal.fire({
                position: 'top-cneter',
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
            })
        }
    }
    const onClickUpdateCurrentPlan = (ele, index) => {
        if (!deleteUpcomingSubLoader) {
            if (subscription.cancelsAt) {
                Swal.fire({
                    title: 'Are you sure you want to renew your plan?',
                    text: `This plan will no longer be canceled. It will renew on ${moment(subscription.endDate).format("DD MMM YYYY")}.`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'No',
                    confirmButtonText: 'Yes, Renew it!',
                    showLoaderOnConfirm: true,
                    allowOutsideClick: () => { },
                    preConfirm: () => {
                        renewCurrentSubscription();
                    },
                });
            } else {
                Swal.fire({
                    title: 'Are you sure you want to cancel your plan?',
                    text: `Your plan will be canceled, but is still available until the end of your billing period on ${moment(subscription.endDate).format("DD MMM YYYY")}.`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: 'No',
                    confirmButtonText: 'Yes, Cancel it!',
                    showLoaderOnConfirm: true,
                    allowOutsideClick: () => { },
                    preConfirm: () => {
                        cancelCurrentSubscription();
                    },
                });
            }
        }
    }
    const onClickSelectedPlan = async (index) => {
        try {
            setLoading({ click: true, index: index });
            const token = window.localStorage.getItem("token");
            if (token) {
                await fetch(`${process.env.REACT_APP_API_ENDPOINT}manage-payment-portal`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        token: token,
                    },
                }).then(async (result) => {
                    const res = await result.json()
                    if (res.url) {
                        window.location.href = res.url;
                        setTimeout(() => {
                            setLoading({ click: false, index: -1 })
                        }, 2000);


                    }
                }).catch(err => console.log("error: fetch API on selected plan =>", err))
            }
        } catch (error) {
            console.log("error on click selected plan =>", error)
        }
    }

    const onClickLoadSetting = async () => {
        try {
            if (!loadSetting) {
                setLoadSetting('settingIcon-CP-img-click');
                const token = window.localStorage.getItem("token");
                if (token) {
                    await fetch(`${process.env.REACT_APP_API_ENDPOINT}manage-payment-portal`, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            token: token,
                        },
                    }).then(async (result) => {
                        const res = await result.json()
                        if (res.url) {
                            window.location.href = res.url;
                            setTimeout(() => {
                                setLoadSetting('');
                            }, 2000);


                        }
                    }).catch(err => console.log("error: fetch API on selected plan =>", err))
                }
            }
        } catch (error) {
            console.log("error on click selected plan =>", error)
        }
    }

    const checkout = async (planId) => {
        const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}create-checkout-session`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'token': getTokenFromLS(),
            },
            body: JSON.stringify({ planId })
        })
        const data = await response.json();
        if (data.status) {

            if (data.status === "failed") {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Something went wrong!',
                })
            } else {
                setLoading({ click: false, index: -1 });
                const planPrice = allPlan.find(ele => ele._id === planId)?.price
                window.fbq('track', 'Subscribe', {value: planPrice.toString(), currency: 'USD', predicted_ltv: '0.00'});
                window.rdt('track', 'Purchase', {value: planPrice.toString(), currency: 'USD',conversionId: "purchase_conversion_28374655"});
                posthog.capture('PlanUpgraded',{
                    $set: {planPrice: planPrice,planActive: true},
                    planPrice: planPrice.toString()
                  });
                setUpCommingSub({
                    upcomingSubscription: {
                        planId: planId,
                        planName: allPlan.find(ele => ele._id === planId)?.name,
                        startDate: moment(data.startAt).format("DD MMM YYYY")
                    }
                })
                Swal.fire({
                    position: 'top-cneter',
                    icon: 'success',
                    title: `New plan will start on ${moment(data.startAt).format("DD MMM YYYY")}`,
                    showConfirmButton: false,
                    timer: 5000
                })
                setSubscription(prevValue => ({ ...prevValue, cancelsAt: data.startAt })); 
            }
        }
        else {
            window.location.href = data.url;
            setTimeout(() => {
                setLoading({ click: false, index: -1 })
            }, 2000);
        }
    }

    const plansDesign = (data) => {
        let selectedOne = monthlySelected ? "month" : "year"
        const dataArray = data.filter((ele) => {
            if (selectedOne === "month") {
                if (ele.billing_period === 1) {
                    return ele;
                }
            } else if (selectedOne === "year") {
                if (ele.billing_period === 12) {
                    return ele;
                }
            }
            return false
        })

        return (
            <div className="main-content" >
                {
                    subscription?.isSubscribed ? (
                        <div className="current-plan">
                            <div className="current-plan-name"><b>{subscription.planName}</b></div>
                            <div className="current-plan-name"><b>Status  - {subscription.status === "active" ? (<span className="active-green">{subscription.status}</span>) : <span className="active-red">{(subscription.status || '').replace(/_/g, ' ')}</span>} </b></div>
                            <div className="current-plan-name"><b>Starts At:</b> {moment(subscription.startDate).format("DD MMM YYYY")} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>End Date:</b> {moment(subscription.endDate).format("DD MMM YYYY")}</div>
                            {subscription.cancelsAt ? (<div className="current-plan-name"><b>Cancels At:</b> {moment(subscription.cancelsAt).format("DD MMM YYYY")}</div>) : ''}
                            <div className="recommend-CP">CURRENT PLAN</div>
                            <div className="settingIcon-CP" title="Manage Current Plan" onClick={onClickLoadSetting}><img className={`settingIcon-CP-img ${loadSetting}`} src={setting} alt="load" /></div>
                            {upcomingSub.upcomingSubscription.planId ? '' : (<div className="settingIcon-CP right5" title={`${subscription.cancelsAt ? "Renew" : "Cancel"} Current Plan`} onClick={onClickUpdateCurrentPlan}><img className={`settingIcon-CP-img right55 ${deleteUpcomingSubLoader}`} src={subscription.cancelsAt ? refreshIcon : deleteIcon} alt="icon" /></div>)}
                        </div>
                    ) : null
                }

                {
                    upcomingSub.upcomingSubscription.planId ? (
                        <div className="current-plan">
                            <div className="recommend-CP">UPCOMING PLAN</div>
                            <div className="current-plan-name"><b>Upcoming Subscription Plan:</b> {upcomingSub.upcomingSubscription.planName} </div>
                            <div className="current-plan-name"> <b> Starts At:</b> {moment(upcomingSub.upcomingSubscription.startDate).format("DD MMM YYYY")} </div>
                            {/* <div className="settingIcon-CP right6" title="Cancel Upcoming Plan" onClick={onClickCancelScheduledPlan}><img className={`settingIcon-CP-img right55 ${deleteUpcomingSubLoader}`} src={deleteIcon} alt="delete" /></div> */}
                        </div>
                    ) : null
                }

                <div className="all-plan">
                    {
                        dataArray.map((ele, index) => {
                            return (
                                <div key={uuidv4()} className="main-plan-div" style={{
                                    background: subscription?.isSubscribed ? subscription.planId === ele._id ? "linear-gradient(180deg, #E3F6F5 0%, #FFFFFF 100%)" : "white" : ele.recommended ? "linear-gradient(180deg, #E3F6F5 0%, #FFFFFF 100%)" : "white"
                                }}>
                                    {
                                        ele?.recommended && <div className="recommend">Recommended</div>
                                    }

                                    {/* contain name of the plan */}
                                    <div className="plan-name">{ele.name}</div>
                                    <div className="plan-specification">{ele?.heading}</div>

                                    {/* contain plan amount details */}
                                    <div className="plan-payment">
                                        <div className="plan-amount">
                                            <span className="plan-dollar">$</span><span>{ele?.price}</span>
                                        </div>
                                        <div className="plan-amt-detail">
                                            <div className="plan-upperPT">Optimise {ele?.images_allowed} images,</div><div className="plan-lowerPT">billed {ele?.description[0]?.details}</div>
                                        </div>
                                    </div>

                                    {/* GET PLAN button */}
                                    {subscription?.isSubscribed ?
                                        (
                                            subscription.planId === ele._id ? (
                                                <div className={loading.index === index ? 'get-plan-button-sub-not-click' : 'get-plan-button-sub-not'} onClick={() => onClickSelectedPlan(index)}>
                                                    {
                                                        loading.index === index ? (
                                                            <div className="loader"></div>
                                                        ) : (
                                                            <div className="currentPlanBtn">
                                                                <div className="currentPlan">SELECTED PLAN</div>
                                                                <img className="settingIcon" src={setting} alt="load" />
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            ) : (
                                                <div className={loading.index === index ? 'get-plan-button-sub-click' : 'get-plan-button-sub'}
                                                    onClick={() => onClickBtnUpgradePlan(ele, index)}
                                                    style={{
                                                        background: upcomingSub.upcomingSubscription?.planId === ele._id ? "rgba(255, 216, 3, 1)" : "white"
                                                    }}  >
                                                    {
                                                        loading.index === index ? (
                                                            <div className="loader"></div>
                                                        ) :
                                                            upcomingSub.upcomingSubscription.planId === ele._id ?
                                                                ('UPCOMING PLAN') : ('UPGRADE PLAN')
                                                    }
                                                </div>
                                            )

                                        ) : (
                                            <div className={loading.index === index ? "get-plan-button-click" : "get-plan-button"} onClick={() => onClickBtn(ele, index)} >
                                                {
                                                    loading.index === index ? (
                                                        <div className="loader"></div>
                                                    ) : ('GET PLAN')
                                                }
                                            </div>
                                        )
                                    }

                                    {/* contain total details about this plan package */}
                                    <div className="plan-detail">
                                        <div className="detail-header">What’s included</div>
                                        <div className="detail-content">
                                            <div className="detailed-content" style={{
                                                fontWeight: "700"
                                            }}><img src={circleImg} alt="load" />
                                                Optimise up to {ele?.images_allowed} images
                                            </div>
                                            <div className="detailed-content"><img src={circleImg} alt="load" />
                                                Unlimited Sites
                                            </div>
                                            <div className="detailed-content"><img src={circleImg} alt="load" />
                                                Upto 80% compression
                                            </div>
                                            <div className="detailed-content"><img src={circleImg} alt="load" />
                                                Webflow CMS Images
                                            </div>
                                            <div className="detailed-content"><img src={circleImg} alt="load" />
                                                Customer Support
                                            </div>
                                            <div className="detailed-content"><img src={circleImg} alt="load" />
                                                Overage: {Math.round(ele.usage_price * 100)} cents per credit
                                            </div>
                                            <div className="detailed-content"><img src={circleImg} alt="load" />
                                                1 credit per operation
                                            </div>
                                            <div className="detailed-content"><img src={circleImg} alt="load" />
                                                1 operation: compress, resize, or/and conversion.
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
    }

    return (
        <div className="main-block-pricing">
            <div className="for-yellowish-BG" style={{
                height: '85%',
            }}>        
            {/* <Link to="#" className="logo" onClick={() => window.history.back()}> */}
                <button className="back-button" onClick={goBackBtn} style={{marginLeft:"11vw" ,marginTop:"5vh"}} ><img src={Back}></img></button>
            {/* </Link> */}
                <div className="main-div">
                    {/* header part */}
                    <div className="main-header">
                        Straightforward pricing
                    </div>

                    {/* contain semi header and button of monthly and anually changed */}
                    <div className="main-semiHeader">
                        <div className="seminHeader-content">
                            Automate the compression and optimization of your Webflow CMS photos to save time and improve the performance of your website.
                        </div>
                        <div className="seminHeader-btn">
                            <div className="btn-div-design">
                                <div className={monthlySelected ? "btn-div-design-select" : "btn-div-design-deselect"} onClick={() => setMonthlySelected(true)}>Monthly</div>
                                <div className={monthlySelected ? "btn-div-design-deselect" : "btn-div-design-select"} onClick={() => setMonthlySelected(false)}>Annually</div>
                            </div>
                        </div>
                    </div>

                    {/* now the all the plans come here */}
                    <div className="plans-div">
                        {
                            plansDesign(allPlan)
                        }
                    </div>

                </div>
            </div>
            {showSurvey && surveyData && (
                <div className="survey-overlay">
                    <div className="survey-modal">
                        <div className="survey-header">
                            {surveyData.questions[0].question}
                            <span className="survey-close" onClick={() => {
                                posthog.capture("survey dismissed", {
                                    $survey_id: surveyData.id
                                });
                                setShowSurvey(false);
                            }}>×</span>
                        </div>
                        <div className="survey-body">
                            <form>
                                {surveyData.questions[0].choices.map((choice, index) => (
                                    <label key={index} className="survey-option">
                                        <input
                                            type="radio"
                                            name="reason"
                                            value={choice}
                                            checked={surveyResponse === choice}
                                            onChange={(e) => setSurveyResponse(e.target.value)}
                                        />
                                        {choice}
                                    </label>
                                ))}
                            </form>
                        </div>
                        <div className="survey-footer">
                            <button className="survey-submit" onClick={() => {
                                posthog.capture("survey sent", {
                                    $survey_id: surveyData.id,
                                    $survey_response: surveyResponse
                                });
                                setShowSurvey(false);
                            }}>Submit</button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}


export default StraightForwardPricing;
